// @mui
import { Box, Stack, Typography } from '@mui/material';

// assets
import { UploadIllustration } from '../../assets';

// ----------------------------------------------------------------------

export default function BlockContent({ multi }) {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      direction={{ xs: 'column', md: 'row' }}
      sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
    >
      <UploadIllustration sx={{ width: 220 }} />

      <Box sx={{ p: 3 }}>
        <Typography gutterBottom variant="h5">
          Drop or Select {multi ? 'files' : 'file'}
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Drop {multi ? 'files' : 'file'} here or click to&nbsp;
          <Typography
            variant="body2"
            component="span"
            sx={{ color: 'primary.main', textDecoration: 'underline' }}
          >
            browse
          </Typography>

        </Typography>
      </Box>
    </Stack>
  );
}
